import { PartitionOutlined } from "@ant-design/icons";
import { Button, Form, Tooltip } from "antd";
import * as React from "react";
import { ZUid } from "src/types/zUid";
import { observer } from "mobx-react-lite";
import { CurrentNodePort } from "src/pages/ManagementPage/objects/ports";
import { GroupO2 } from "../../Obj2Nodes";
import { edAttrField } from "../../EdAttribute";

const unique = (arr: ZUid[]): ZUid[] =>
  arr.filter((value, index, self) => self.indexOf(value) === index);

interface PropsCopyOnMnemonicGroupButton {
  store: CurrentNodePort;
  stateName: string;
  stateId: ZUid;
  owner?: GroupO2;
}

export const CopyOnMnemonicGroupButton: React.FC<PropsCopyOnMnemonicGroupButton> =
  observer(({ store, stateName, stateId, owner }) => {
    const form = Form.useFormInstance();
    const copyStatesForMnemonicGroup: ZUid[] | undefined = Form.useWatch(
      edAttrField.copyStatesForMnemonicGroup,
    );

    const text = owner
      ? `Перенести на состояние ${stateName} для всех атрибутов мнемонической группы ${owner.group.name}`
      : null;

    const copyOnMnemonicGroup = () => {
      const newValue = copyStatesForMnemonicGroup
        ? unique([...copyStatesForMnemonicGroup, stateId])
        : [stateId];
      form.setFieldValue(edAttrField.copyStatesForMnemonicGroup, newValue);
      store.formStore.setFormStatus("changed");
    };

    return (
      <Tooltip title={text}>
        <Button
          size="small"
          type="text"
          icon={<PartitionOutlined />}
          disabled={!owner}
          onClick={(event) => {
            event.stopPropagation();
            copyOnMnemonicGroup();
          }}
        />
      </Tooltip>
    );
  });
